<script>
  import { getContext } from 'svelte';
  import { Route, Router } from 'svelte-navigator';

  import Redirect from '@client/app/redirect.svelte';

  import { Editorial } from './editorial';
  import { Manage, ManageEdit } from './manage';

  const { basepath } = getContext('config');
</script>

<Router>
  <Route path="/">
    <Route>
      <Manage />
    </Route>
  </Route>
  <Route path=":id">
    <ManageEdit />
  </Route>
  <Route path="editorial">
    <Editorial />
  </Route>
  <Route path="/*">
    <Redirect path="{basepath}/marketing/" config={{ replace: true }} />
  </Route>
</Router>
